import { NavLink, useSearchParams } from 'react-router-dom';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {faFutbol} from "@fortawesome/free-regular-svg-icons"
import Container from 'react-bootstrap/Container';
import Navbar from 'react-bootstrap/Navbar';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Offcanvas from 'react-bootstrap/Offcanvas';
import { Row, Col } from 'react-bootstrap';
import { useEffect, useState } from 'react';

interface IBrandProps {
  subscribe: (leagueID: string) => void;
}
 
export function BrandNavbar(props: IBrandProps) {
  const [searchParams] = useSearchParams();
  const [leagueID, setLeagueID] = useState<string>("");
  const {subscribe} = props;

  useEffect(() => {
    const val = searchParams.get("league_id");
    if (val) {
      setLeagueID(val);
      subscribe(val);
    }
    
  }, [searchParams,subscribe])

  const onSubmit = (event: React.SubmitEvent) => {
    event.preventDefault();
    props.subscribe(leagueID);
  };
  
  return (
    <Navbar expand={true} className="bg-body-tertiary mb-4">
      <Container fluid>
        <Navbar.Brand as={NavLink} to="/"><FontAwesomeIcon icon={faFutbol}/>Games Gone</Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Offcanvas
          id={`offcanvasNavbar-expand-${false}`}
          aria-labelledby={`offcanvasNavbarLabel-expand-${false}`}
          placement="end"
        >
        <Row>
          <Col>
            <Offcanvas.Header closeButton>
              <Offcanvas.Title id={`offcanvasNavbarLabel-expand-${false}`}>
                Games Gone
              </Offcanvas.Title>
            </Offcanvas.Header>
          </Col>
          <Col md="auto"/>
          <Col>
          <Offcanvas.Body>
            <Form className="d-flex" onSubmit={onSubmit} autoComplete="on">
              <Form.Control
                type="text"
                placeholder="League ID"
                className="me-2"
                aria-label="Search"
                value={leagueID}
                onChange={(event) => setLeagueID(event.target.value)}
              />
              <Button type="submit" variant="outline-success">Select</Button>
            </Form>
          </Offcanvas.Body>
          </Col>
        </Row>
        </Navbar.Offcanvas>
      </Container>
    </Navbar>
  )
}
